const bg = {
  "Home": "Начало",
  "Add": "Добави",
  "Edit": "Редакция",
  "Adding": "Добавяне на",
  "Editing": "Редактиране на",
  "Delete": "Изтрий",
  "Save": "Запис",
  "Cancel": "Отказ",
  "Close": "Затвори",
  "Open": "Отвори",
  'Medicines': 'Лекарства',
  'OverviewAbout': 'Какво представлява и за какво се използва',
  'OverviewBeforeIntake': 'Какво трябва да знаете преди да използвате',
  'OverviewDosage': 'Как да използвате',
  'OverviewSideEffects': 'Възможни нежелани реакции',
  'OverviewSafetyData': ' Как да съхранявате',
  'OverviewAdditionalInfo': 'Съдържание на опаковката и допълнителна информация',
  'LeafletUserInfo': 'Листовка: информация за потребителя',
  'WhatIsInLeaflet': 'Какво съдържа тази листовка:',
  'WhatIsInProduct': 'Какво съдържа',
  'ActiveIngredients': 'Активни вещества',
  'WhatLooksAndPackageContents': 'Как изглежда и какво съдържа опаковка',
  'FirstSideImprint': 'означени от едната страна с',
  'NotAllPackagesMarketed': 'Не всички видове опаковки могат да бъдат пуснати в продажба.',
  'MarketingAuthorisationHolderAndManufacturer': 'Притежател на разрешението за употреба и производител',
  'Manufacturer': 'Производител',
  'LeafletLastRevisedIn': 'Дата на последно преразглеждане на листовката',
  'BrandName': 'Търговско име',
  'GenericName': 'Генерично име',
  'Overview': 'Преглед',
  'SideEffects': 'Странични ефекти',
  'Dosage': 'Дозировка',
  'Professional': 'За професионалисти',
  'Interactions': 'Взаимодействия',
  'Leaflet': 'Листовка',
  'InactiveIngredients': 'Неактивни вещества',
  'LeafletForUser': 'Листовка за пациента',
  'SmPC': 'Кратка характеристика на продукта',
  'Leaflets': 'Листовки',
  'FilesForDownload': 'Файлове за сваляне',
  'Pregnancy': 'Бременост',
  'Breastfeeding': 'Кърмене',
  'MarketingAuthorisationHolder': 'Притежател на разрешението за употреба',
  'StoragePlace': 'Място на съхранение',
  'StoragePlace and storagePrecautions': 'Място и условия на съхранение',
  'storagePrecautions': 'Условия на съхранение',
  'ShelfLife': 'Срок на годност',
  'ProductHandling': 'Специални предпазни мерки при употреба',
  'ProductHandlingAndDisposal': 'Специални предпазни мерки при употреба и изхвърляне',
  'ProductDisposal': 'Специални предпазни мерки при изхвърляне',
  'SafetyData': 'Безопасност',
  'Profession': 'Професия',
  'Driver': 'Шофьор',
  'MachineOperator': 'Оператор на машина',
  '5004': 'Несъществуваща рецепта',
  '5005': 'Несъществуваща аларма',
  '5006': 'Невалидна дата на аларма',
  '5007': 'Несъществуващ график на аларма',
  '6000': 'Несъществуваща активна съставка',
  '6001': 'Невалидни странични ефекти',
  '6002': 'Невалидни дозировки',
  '6003': 'Несъществуваща болест',
  '6004': 'Несъществуващи храна или алкохол',
  '6005': 'Несъществуваща неактвина съставка',
  '6006': 'Несъществуващ производител',
  '6007': 'Невалидни бременост или кърмене',
  '6008': 'Невалидни шофьор или машина',
  '6009': 'Невалидни данни за сигурност',
  'EmaEparFile': 'EMA EPAR File',
  'EmaEparText': 'EMA EPAR Text',
  'ImportFailed': 'Import Failed',
  'NotSynchronized': 'Not Synchronized',
  'SynchronizationFailed': 'Synchronization Failed',
  'NewAuthorisationGranted': 'New Authorisation Granted',
  'NewAuthorisationSuspended': 'New Authorisation Suspended',
  'DocumentGenerationFailed': 'Document Generation Failed',
  // 'DriveMachine': 'Шофиране / Машина',
  // 'When driving': 'При шофиране',
  // 'When using machine': 'При работа с машини'
  '13006': 'Грешка при генерирането на документи. Моля, опитайте отново!',
  '13007': 'Грешка при транзакция. Свържете се с вашия администратор!',
  '13008': 'Грешка при генериранеот на URL пътя. Моля, свалете EPAR документа ръчно!',
  'Pregnancy and Breastfeeding': 'Бременност, кърмене и фертилитет',
  'DrivingAndUsingMachines': 'Шофиране и работа с машини',
  '13009': 'Синхронизирани лекарства не могат да бъдат изтрити!',
  'EPAR': 'Кратка характеристика на продукта и Листовка за пациента',
  'DocCountsEqual': 'Equal number',
  'SingleDoc': 'Single doc',
  'FirstAtStartToMissing': 'First at start',
  'LastAtEndToMissing': 'Last at end',
  'StebByStepFromStart': 'Steb by step',
  '13010': 'Multi Language documents count different!',
  'BDAhtml': 'BDA HTML',
  'SynchronizedBdaHtml': 'Synchronized BDA',
  'Please enter Email': 'Моля въведете Електронна поща',
  'Please enter valid Email': 'Моля въведете валидна Електронна поща',
  '4003': 'Вече има регистриран потребител с тази Електронна поща.',
}

export default bg;